export default {
  search: 'جستجو',
  searchHint: 'جستجو با نام / شماره تلفن / ایمیل',
  blocked: 'مسدود شده',
  userId: 'شناسه',
  phone: 'تلفن',
  email: 'ایمیل',
  name: 'نام',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  password: 'کلمه عبور',
  active2fa: '2FA',
  enabled: 'فعال',
  unblock: 'رفع مسدودی',
  save: 'ذخیره',
  securityLogs: 'رخدادهای امنیتی',
  details: 'مشخصات',
  ipaddress: 'ip address',
  date: 'زمان',
  actor: 'کاربر',
  type: 'نوع',
  level: 'سطح',
  description: 'توضیح',
  ip: 'ip',
  value: 'مقدار',
  configUpdated: 'تنظیمات ذخیره شد.',
};
